import React from 'react'
import { Link } from 'react-router-dom'
import { ArrowLeftOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import { MAPPING_MATRIX_ROUTE } from '../mappingRoutes'

const MappingExitLink: React.FC = () => {
  const { t } = useTranslation()

  return (
    <div style={{ marginBottom: 12 }}>
      <Link
        to={MAPPING_MATRIX_ROUTE}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 6,
          fontSize: 13,
          fontWeight: 500,
          color: 'rgba(0, 0, 0, 0.65)'
        }}
      >
        <ArrowLeftOutlined style={{ fontSize: 12 }} />
        {t('groupCustomerMapping:exitToMatrix', 'Konsernin asiakas- ja toimittajalinkitys')}
      </Link>
    </div>
  )
}

export default MappingExitLink
